<success-screen class="bp-modal mod-lg">
	<bp-modal-header header [title]="fiatTransaction?.getType() + '_success' | translate: [fiat.getName()]">
		<a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<div content>
		<div class="success-content-inner">
			<div class="attention-symbol mod-green mb-20 mt-70">
				<span class="bpi__icon-attention"></span>
			</div>
			<div class="success-headline mod-fraud mb-15">
				{{ fiatTransaction?.getType() + "_potential_fraud_problem" | translate }}
			</div>
			<p class="text-center mb-20 font-size-15">
				<span>{{ fiatTransaction?.getType() + "_potential_fraud_description" | translate }}</span>
			</p>
			<div class="mb-50 text-center">
				<a [href]="getHelpdeskLink()" class="btn btn-primary btn-success-modal mod-middle" [target]="'_blank'">
					{{ fiatTransaction?.getType() + "_potential_fraud_button" | translate }}
				</a>
			</div>
		</div>
		<div class="text-center">
			<button (click)="close()" class="btn btn-primary btn-success-modal" type="button">
				<strong>{{ "close" | translate }}</strong>
			</button>
		</div>
	</div>
</success-screen>
